import { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { BoxStyled, Title, WrapperIcon } from './style';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';

interface ModalProps {
  title?: string | undefined;
  open: boolean;
  onCloseHandler: () => void;
  titleIconStart?: React.ReactNode | undefined;
}

const BasicModal = ({ open, onCloseHandler, title, titleIconStart, children }: PropsWithChildren<ModalProps>) => {
  return (
    <Modal
      keepMounted
      open={open}
      onClose={onCloseHandler}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <BoxStyled>
        <CloseIcon onClick={onCloseHandler} sx={{ cursor: 'pointer' }} data-testid="icon-close" />
        {title && (
          <Title id="modal-modal-title" variant="h2">
            {titleIconStart && (
              <>
                <WrapperIcon>{titleIconStart}</WrapperIcon>{' '}
              </>
            )}
            {title}
          </Title>
        )}
        <Box id="modal-modal-description" sx={{ mt: 2 }}>
          {children}
        </Box>
      </BoxStyled>
    </Modal>
  );
};

export default BasicModal;
